<template>
	<div id="slideshow-container">
		<div class="slide-image">
			<transition name="slide">
				<v-container fluid v-if="slideKey == 1">
					<v-row row-wrap class="row-1">
						<v-col class="text-col pa-12" cols="7">
							<p class="text-h3">ERP</p>
							<p class="text-h4">Enterprise-Resource-Planning</p>
						</v-col>
						<v-col cols="5" class="pa-12">
							<img :src="slideOne"/>
						</v-col>
					</v-row>
				</v-container>

				<v-container fluid v-if="slideKey == 2">
					<v-row row-wrap class="row-2">
						<v-col class="text-col pa-12" cols="5">
							<p class="text-h3">Big Data</p>
							<p class="text-h4">In Memory Computing</p>
						</v-col>
						<v-col cols="7" class="pa-12 col-2-2">
							<img :src="slideTwoTwo"/>
							<img cols="3" :src="slideTwoOne"/>
						</v-col>
					</v-row>
				</v-container>
				
				<v-container fluid v-if="slideKey == 3">
					<v-row row-wrap class="row-3">
						<v-col class="text-col pa-12" cols="5">
							<p class="text-h3">INDIVIDUAL SOFTWARE</p>
							<p class="text-h4">Konzeption | Design | Development</p>
						</v-col>
						<v-col cols="7" class="pa-12 col-3-2">
							<img :src="slideThreeOne"/>
							<img cols="3" :src="slideThreeTwo"/>
						</v-col>
					</v-row>
				</v-container>
				
				<v-container fluid v-if="slideKey == 4">
					<v-row row-wrap class="row-4">
						<v-col cols="7" class="pa-12">
							<img :src="slideFour"/>
						</v-col>
						<v-col class="text-col pa-12 col-4-2" cols="8">
							<p class="text-h3">INDUSTRIE 4.0</p>
							<p class="text-h4">Produktion | Automatisierung | Logistik</p>
						</v-col>
					</v-row>
				</v-container>
				
				<v-container fluid v-if="slideKey == 5">
					<v-row row-wrap class="row-5">
						<v-col cols="7" class="pa-12 col-5-1">
							<img :src="slideFiveOne"/>
							<img :src="slideFiveTwo"/>
						</v-col>
						<v-col class="text-col pa-12" cols="5">
							<p class="text-h3">Team</p>
							<p class="text-h4">Wir suchen Verstärkung</p>
						</v-col>
					</v-row>
				</v-container>
			</transition>

			<a class="prev" @click="activateSlides(-1)">
				<v-icon>mdi-chevron-left</v-icon>
			</a>
	
			<a class="next" @click="activateSlides(1)">
				<v-icon>mdi-chevron-right</v-icon>
			</a>
			<p class="text-h3 welcome">Willkommen</p>
		</div>
	</div>
</template>

<script>

	export default {
		name: "SlideshowComponent",
		data: function() {
			return {
				slideEnterRight: "translate(-100%, 0)",
				myInterval: "",
				
				slideKey: 1,

				images: Array,
				
				slideOne: require("../../assets/slide1.png"),

				slideTwoOne: require("../../assets/slide21.png"),
				slideTwoTwo: require("../../assets/slide22.png"),
				
				slideThreeOne: require("../../assets/slide31.png"),
				slideThreeTwo: require("../../assets/slide32.png"),
				
				slideFour: require("../../assets/slide4.png"),
				
				slideFiveOne: require("../../assets/slide51.png"),
				slideFiveTwo: require("../../assets/slide52.png"),
			}
		},

		props: {
			pictures: Array,
			cmsUrlBase: String,
		},

		methods: {
			activateSlides(n) {
				clearInterval(this.myInterval);
				if (n == 1 && this.slideKey == 5) {
					this.slideKey = 1;
				} else if (n == -1 && this.slideKey == 1) {
					this.slideKey = 5;
				} else {
					this.slideKey += n;
				}

				this.plusSlides(n);
			},

			plusSlides(n) {
				var root = document.documentElement;

				if(n > 0) {
				//Next image
						root.style.setProperty("--opacityNext", 0);
						root.style.setProperty("--opacityPrev", 1);

						const first = this.images.shift();
						this.images = this.images.concat(first);
				} else {
				//Previouse image
						root.style.setProperty("--opacityNext", 1);
						root.style.setProperty("--opacityPrev", 0);

						const last = this.images.pop();
						this.images = [last].concat(this.images);
				} 
			},
		},


		beforeDestroy() {
			clearInterval(this.myInterval);
		}
	}
</script>

<style>
:root {
	--positionSecondRight: auto;
	--positionSecondLeft: 100%;
	--positionLastRight: 100%;
	--positionLastLeft: auto;
	
	--opacityNext: 0;
	--opacityPrev: 0;
}
</style>

<style scoped>

.welcome {
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	bottom: 0px;
	font-size: 35px !important;
}

.text-col {
	display: flex;
	flex-direction: column;
	justify-content: center;
	color: white;
}

.row-1 img {
	height: 100%;
	width: auto;
	margin-top: 0em;
	transform: translateX(-20%);
}

.row-2 >>> .row, .row-3 >>> .row{
	transform: translateX(50%);
}

.row-2 img{
	height: 90%;
	width: 60%;
}

.row-2 img:last-child {
	transform: translateX(-50%)
}

.row-3 .col, .row-5 .col{
	display: flex;
	align-items: center;
}

.row-3 img:first-child {
	z-index: 10;
	transform: translateX(-20%);
}

.row-3 img:last-child {
	height: 70%;
	transform: translateX(-100%);
	
}

.col-2-2, .col-3-2 {
	display: flex;
}

.row-4 .text-col {
	justify-content: end;
}

.row-4 img {
	height: 90%;
	margin-left: -20px;
}

.col-4-2 {
	position: absolute;
	bottom: 20%;
	left: 40%;
}

.row-5 .text-col {
	align-items: start;
}

.row-5 img:first-child {
	z-index: 10;
}

.row-5 img:last-child {
	height: 80%;
	transform: translate(-40%, -10%);
}

.carousel-transiton-move {
	transition: tranform 1s;
}

.slide {
	opacity: 0;
	overflow: hidden;
	transition: transform 1s ease-in-out;
}

.carousel .slide:first-of-type {
	z-index: 0;
	opacity: 1;
	right: auto;
	left: auto;
}

.slide:nth-of-type(2) {
	opacity: var(--opacityNext);
	position: absolute;
	right: var(--positionSecondRight);
	left: var(--positionSecondLeft);
}

.slide:last-of-type {
	opacity: var(--opacityPrev);
	position: absolute;
	left: var(--positionLastLeft);
	right: var(--positionLastRight);
}

#slideshow-container {
	width: 100%;
	bottom: 0;
	margin: auto;
	position: relative;
	height: 500px;
	background-image: url("../../assets/Background.png");
	background-size: 100%;
}

.slide-image {
	height: 500px;
	overflow: hidden;
	display: block;
}

.slide-image div{
	height: 100%;
}

img {
	height: 100%;
	width: 100%;
}

.prev i {
	border-top-left-radius: 100%;
	border-bottom-left-radius: 100%;
}

.next i {
	border-top-right-radius: 100%;
	border-bottom-right-radius: 100%;
}

.prev i, .next i {
	font-size: 80px;

	background-color: #fa7b05;
}
	
.prev, .next {
	cursor: pointer;
	position: absolute;
	top: 50%;
	width: auto;
	font-weight: bold;
	font-size: 88px;
	color: white;
}



.prev {
	left: 0;
	transform: translate(-100%, -50%);
}

.next {
	right: 0;
	transform: translate(100%, -50%);
}
	
@media(max-width: 991px) {


	.slide-image {
		height: 50vh;
	}

}

@media(max-width: 767px) {
	.slide-image {
		height: 40vh;
	}

	.prev, .next {
		width: 35px;
	}
}

@media(max-width: 575px) {
	.slide-image {
		height: 30vh;
	}

	.prev, .next {
		width: 23px;
	}
}

</style>